import React, { Component } from "react";
import Header from "../../components/Header";
import Loader from "../../components/Loader";
import SatisfactionSurvey from "../../components/SatisfactionSurvey";
import Ticket from "../../components/Ticket";
import api from "../../services/api";
import { Container } from "./styles";
import NotFound from "../../components/NotFound";
import i18n from "../../config/i18n";
import { captureException } from "@sentry/browser";

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      loading: true,
      language: "pt",
      error: false
    };
  }

  async componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    let token = "";
    let language = "";

    if (params.get("t")) {
      token = params.get("t");
    }

    
  if (params.get("language")) {
    language = params.get("language");
  }

    if (!token.length) {
      token = decodeURIComponent(window.location.search.substr(1));
    }

    try {
      const response = await api.get(`/?token=${encodeURIComponent(token)}&language=${encodeURIComponent(language)}`);
      const data = await this.checkEmailResponse(response.data);
      this.handleChangeLanguage(data.defaultLanguage);
      this.setState({ data });
    } catch (error) {
      captureException(error);
      this.setState({ error: true });
    }

    this.setState({ loading: false });
  }

  checkEmailResponse = async data => {
    const { satisfactionSurveyResponse, questions } = data;
    if (satisfactionSurveyResponse) {
      const first = questions.shift();
      if (!(await this.sendResponse(first.id, satisfactionSurveyResponse))) {
        return { ...data, questions: [{ ...first }, ...questions] };
      }
      const newQuestions = [
        { ...first, response: satisfactionSurveyResponse },
        ...questions
      ];
      return { ...data, questions: newQuestions };
    }

    return data;
  };

  sendResponse = async (id, response) => {
    try {
      const params = new URLSearchParams(window.location.search);
      let token = "";
      if (params.get("t")) {
        token = params.get("t");
      }

      if (!token.length) {
        token = decodeURIComponent(window.location.search.substr(1));
      }
      await api.patch(`/${id}/response?token=${encodeURIComponent(token)}`, {
        response
      });
      return true;
    } catch (error) {
      captureException(error);
      console.error("Resposta não enviada para o servidor");
      return false;
    }
  };

  handleChangeLanguage = lang => {
    const { language } = this.state;
    lang = lang.substring(0, 2);
    if (lang === language) return;

    i18n.changeLanguage(lang);
    this.setState({ language: lang });
  };

  render() {
    const { data, loading, error, language } = this.state;
    return (
      <Container>
        <Header
          handleChangeLanguage={this.handleChangeLanguage}
          backgroundColor={data.mainPageBackgroundColor}
          tenantId={data.owner ? data.owner.tenantId : 0}
        />

        {loading && <Loader />}
        {error && <NotFound />}
        {!error && !loading && (
          <>
            <SatisfactionSurvey questions={data.questions} lang={language} />
            <Ticket data={data} />
          </>
        )}
      </Container>
    );
  }
}

export default Main;
